import React, { useState } from 'react'
import { Avatar } from 'react-angle-dashboard-components'
import { Button } from 'react-angle-dashboard-components/node_modules/react-bootstrap'

import {
  WrapperFac,
  Content,
  Title,
  MainPro,
  WrapperPro,
  MainFac
} from './style'

export interface IDirectoryItemCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  subtitle?: string
  image?: string
  children?: React.ReactNode
  badge?: React.ReactNode
  distance?: string
  circledImage?: boolean
  locations?: Array<any>
  [x: string]: any
}

export const ItemCard: React.FC<IDirectoryItemCardProps> = ({
  title,
  subtitle,
  image,
  children,
  badge,
  distance,
  address,
  circledImage = false,
  locations = [],
  ...p
}) => {
  const wrapperStyles = p.onClick
    ? {
        ...p.style,
        cursor: 'pointer'
      }
    : { ...p.style }
  const [arrow, setArrow] = useState(false)

  const primaryService = p.services?.length ? p.services[0] : ''
  const primarySpecialty = p.specialties?.length ? p.specialties[0] : ''
  return (
    <>
      {circledImage ? (
        <WrapperPro {...p} style={wrapperStyles}>
          <Avatar
            avatarImagePath={image}
            fallbackContent={<i className="icon icon-user text-primary" />}
            circle
            style={{ marginTop: '1rem' }}
            size="lg"
            variant="primary-light"
          />
          <MainPro>
            <div
              className="d-flex justify-content-between"
              style={{ position: 'relative', bottom: '0' }}
            >
              <div>
                <Title>
                  <h3 className="fs-18 text-capitalize">{title}</h3>
                  {badge}
                </Title>
                {primarySpecialty && (
                  <small className="text-muted fs-14 mt-1 d-block text-capitalize text-truncate">
                    {primarySpecialty}
                  </small>
                )}
              </div>
              <Button
                variant="link"
                className="fs-12 d-block text-capitalize px-0 py-0 text-nowrap"
                onMouseOver={() => setArrow(true)}
                onMouseLeave={() => setArrow(false)}
              >
                Visit Profile
                {arrow && (
                  <i
                    className="fs-10 icon icon-right-arrow text-primary px-0 py-0"
                    style={{
                      marginRight: '-20px',
                      marginLeft: '-15px',
                      marginTop: '-15px',
                      marginBottom: '-15px'
                    }}
                  />
                )}
              </Button>
            </div>
            {locations.length && (
              <div
                className="d-flex"
                // style={{ position: 'relative', bottom: '0' }}
              >
                <i
                  className="fs-12 icon icon-location text-muted"
                  style={{ marginLeft: '-17px', height: '20px' }}
                />
                <small
                  className="text-muted fs-12 d-block text-capitalize"
                  style={{ marginLeft: '-12px' }}
                >
                  {locations.length === 1
                    ? '1 Location'
                    : `${locations.length} Locations`}
                </small>
              </div>
            )}
            {children ? (<Content>{children}</Content>) : null}
          </MainPro>
        </WrapperPro>
      ) : (
        <WrapperFac {...p} style={wrapperStyles}>
          <Avatar
            data-testid="directory-item-image"
            circle
            avatarImagePath={image}
            fallbackContent={
              <i className="icon icon-facility fs-48 text-primary" />
            }
            size="lg"
            variant="primary-light"
            style={{ marginTop: '1.1rem' }}
          />
          <MainFac>
            <Title>
              <h3 className="fs-20 text-capitalize">{title}</h3>
              {badge}
            </Title>
            {primaryService && (
              <small className="text-muted fs-12 d-block text-capitalize text-truncate">
                {primaryService}
              </small>
            )}
            {address && (
              <small className="text-dark fs-14 d-block text-capitalize pt-2">
                {address}
              </small>
            )}
            <div
              className="d-flex justify-content-between mt-3"
              style={{ position: 'relative', bottom: '0' }}
            >
              <Button
                variant="link"
                className="fs-12 d-block text-capitalize px-0 py-0"
              >
                Visit Facility
              </Button>
              <small className="text-muted fs-12 d-block text-capitalize">
                {distance}
              </small>
            </div>
            <Content>{children}</Content>
          </MainFac>
        </WrapperFac>
      )}
    </>
  )
}

export const DirectoryItemCard = React.memo(ItemCard)
export default DirectoryItemCard
